Postlogin.Lesson = Postlogin.Lesson || {};
Postlogin.Lesson.Progress = (function () {
    let isOpen = false;
    let progressNav = null;

    // when user opens menu, we attempt to pause the current segment
    // if the segment was playing, and we actually paused it, remember to
    // play it again when we close the menu. It it was already paused when
    // the user opens the menu, don't play it when they close it
    let playWhenClosed = false;
    const init = function () {
        initEvents();

        // initialize segment navigation
        progressNav = $('.lesson-navigation-wrapper .icon-list');

        $(progressNav).flickity({
            initialIndex: Postlogin.Lesson.getCurrentSegmentIndex() - 1,
            cellAlign: 'center',
            pageDots: false,
            prevNextButtons: false,
        });

        $(progressNav).on('dragStart.flickity', function () {
            $(this).addClass('is-dragging');
        });

        $(progressNav).on('dragEnd.flickity', function () {
            $(this).removeClass('is-dragging');
        });

        $(progressNav).on('click', '.segment-nav-blip', function (e) {
            e.preventDefault();
            const index = $(this).attr('data-loop-index');

            $(progressNav).flickity('select', index);
            selectSegment(index);
            $(progressNav).flickity('resize');

            Postlogin.Lesson.goToSegment(index);
            toggleMenu();
        });
    };

    /* Add all the segment blips to the Progress Nav */
    const populate = function (segments) {
        $.each(segments, (i, segment) => {
            const $a = $('<a></a>');
            $a.attr('href', `#segment-${segment.segment_id}`);
            $a.attr('id', `segment-nav-blip-${segment.segment_index}`);
            $a.attr('data-segment-id', segment.segment_id);
            $a.attr('data-loop-index', segment.segment_index);
            $a.attr('tabindex', '-1');
            if (segment.display_name !== '') {
                $a.attr('title', segment.display_name);
            } else {
                $a.attr('title', segment.name);
            }
            $a.addClass('nav-blip');
            $a.addClass('segment-nav-blip');
            // $a.addClass('tooltipster');
            $a.tooltipster({
                theme: 'tooltipster-vjs',
                animation: 'fade',
                delay: [50, 0],
            });

            if (segment.date_started || segment.segment_id === Postlogin.Lesson.getCurrentSegmentId()) {
                $a.addClass('started');
            }
            if (segment.date_completed) {
                $a.addClass('completed');
            }
            if (segment.segment_index === Postlogin.Lesson.getFurthestSegmentIndex()) {
                $a.addClass('furthest');
            }
            if (segment.segment_index === Postlogin.Lesson.getCurrentSegmentIndex()) {
                $a.addClass('current');
            }

            const $icon = $('<i></i>');
            $icon.addClass('fa');
            $icon.attr('aria-hidden', 'true');

            if (segment.type_slug === 'video') {
                $icon.addClass('fa-video-camera');
            } else if (segment.type_slug === 'activity') {
                if (segment.activity_type_slug === 'image-scramble') {
                    $icon.addClass('fa-puzzle-piece');
                } else if (segment.activity_type_slug === 'written-response') {
                    $icon.addClass('fa-pencil');
                } else {
                    $icon.addClass('fa-question');
                }
            } else if (segment.type_slug === 'html-content') {
                $icon.addClass('fa-align-left');
            }

            $a.append($('<span></span>').append($icon));
            $(progressNav).flickity('append', $('<div></div>').append($a));
        });
    };

    const initEvents = function () {
        // Handle opening and closing of the My Progress menu
        $('#open-button').on('click', toggleMenu);

        if ($('#close-button').length) {
            $('#close-button').on('click', toggleMenu);
        }

        // close the menu element if the target it´s not the menu element or one of its descendants..
        $('body').on('click', '#content-container', (ev) => {
            const { target } = ev;
            if (isOpen && target !== $('#open-button')) {
                toggleMenu();
            }
        });
    };

    const toggleMenu = function () {
        if (isOpen) {
            $('body').removeClass('show-menu');
            $('#content-container, #clouds-background-container').removeClass('blur');

            if (playWhenClosed) {
                Postlogin.Lesson.playCurrentSegment();
            }
        } else {
            $(progressNav).flickity('resize');
            $(progressNav).flickity('reposition');
            $('body').addClass('show-menu');
            $('#content-container, #clouds-background-container').addClass('blur');
            playWhenClosed = Postlogin.Lesson.pauseCurrentSegment();
        }
        isOpen = !isOpen;
    };

    const completeSegment = function (segmentIndex) {
        $(`#segment-nav-blip-${segmentIndex}`).addClass('completed');
    };

    const selectSegment = function (segmentIndex) {
        if (!$(`#segment-nav-blip-${segmentIndex}`).hasClass('started')) {
            $('.segment-nav-blip.furthest').removeClass('furthest');
            $(`#segment-nav-blip-${segmentIndex}`).addClass('furthest started');
        }
        $('.segment-nav-blip.current').removeClass('current');
        $(`#segment-nav-blip-${segmentIndex}`).addClass('current');
        $(progressNav).flickity('select', segmentIndex);
    };

    const updatePercentComplete = function (percentage) {
        $('#lesson-percentage-complete').html(` — ${percentage}%`);
    };

    return {
        init,
        populate,
        selectSegment,
        completeSegment,
        updatePercentComplete,
    };
}());
